const Joi = require("joi");

// const userRoleID = Number(sessionStorage.getItem("userRoleID"));

const allowedMimeTypes = [
  "image/jpeg", // .jpg, .jpeg
  "image/png", // .png
  "image/heic", // .heic
  "image/heif", // some browsers use this for HEIF/HEIC
];

const myProfileSchema = (data, userRoleID) => {
  const schema = Joi.object({
    firstName: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$"))
      .required()
      .max(25)
      .messages({
        "string.pattern.base": "Please enter valid First name.",
        "string.max": "Please enter First name with fewer than 25 characters.",
        "any.required": "Please enter First name.",
        "string.empty": "Please enter First name.",
      }),

    lastName: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$"))
      .required()
      .max(25)
      .messages({
        "string.pattern.base": "Please enter valid Last name.",
        "string.max": "Please enter Last name with fewer than 25 characters.",
        "any.required": "Please enter Last name.",
        "string.empty": "Please enter Last name.",
      }),

    email: Joi.string()
      .trim()
      .email({ tlds: { allow: false } })
      .pattern(
        new RegExp(
          /^(?!.*\.\.)[a-zA-Z0-9._%!#$*+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
        )
      )
      .required()
      .messages({
        "string.email": "Please enter valid email.",
        "string.pattern.base": "Please enter valid email.",
        "string.empty": "Please enter email.",
        "any.required": "Please enter email.",
      }),

    committees:
      userRoleID === 3
        ? Joi.any().strip()
        : Joi.array()
            .items(
              Joi.string().required().messages({
                "string.base": "Invalid Committee", //not a string
                "any.required": "Committee ID is required.",
              })
            )
            .min(1)
            .required()
            .messages({
              "array.base": "Committees must be an array.",
              "array.min": "Please select at least one committee.",
              "any.required": "Committees are required.",
            }),

    organization: Joi.string()
      .trim()
      .max(256)
      .when("participateKids", {
        is: 1,
        then: Joi.string().required().messages({
          "string.empty": "Organization name is required.",
          "string.max": "Organization name must be fewer than 256 characters.",
        }),
        otherwise: Joi.string().optional().allow(""),
      }),

    // Photo: Joi.alternatives()
    //   .try(
    //     // Case 1: String path
    //     Joi.string()
    //       .pattern(/\.(jpg|jpeg|png|heic)$/i)
    //       .messages({
    //         "string.pattern.base":
    //           "Invalid image format. Only JPG, JPEG, PNG, HEIC are allowed.",
    //       }),

    //     // Case 2: File object
    //     Joi.object({
    //       name: Joi.string()
    //         .pattern(/\.(jpg|jpeg|png|heic)$/i)
    //         .required()
    //         .messages({
    //           "string.pattern.base":
    //             "Invalid image file name. Only JPG, JPEG, PNG, HEIC are allowed.",
    //         }),
    //       type: Joi.string()
    //         .valid(...allowedMimeTypes)
    //         .required()
    //         .messages({
    //           "any.only":
    //             "Invalid image type. Only JPG, JPEG, PNG, HEIC are allowed.",
    //         }),
    //     })
    //   )
    //   .required()
    //   .messages({
    //     "any.required": "Please upload a photo.", // empty / missing value
    //     "alternatives.match":
    //       "Invalid image format. Only JPG, JPEG, PNG, HEIC are allowed.", // value exists but doesn’t match branches (like .gif)
    //   }),

    Photo: Joi.alternatives()
      .try(
        // Case 1: String path
        Joi.string()
          .pattern(/\.(jpg|jpeg|png|heic)$/i)
          .messages({
            "string.pattern.base":
              "Invalid image format. Only JPG, JPEG, PNG, HEIC are allowed.",
          }),

        // Case 2: File object
        Joi.object({
          name: Joi.string()
            .pattern(/\.(jpg|jpeg|png|heic)$/i)
            .required()
            .messages({
              "string.pattern.base":
                "Invalid image file name. Only JPG, JPEG, PNG, HEIC are allowed.",
            }),
          type: Joi.string()
            .valid(...allowedMimeTypes)
            .required()
            .messages({
              "any.only":
                "Invalid image type. Only JPG, JPEG, PNG, HEIC are allowed.",
            }),
        })
      )
      .optional() // photo is not mandatory
      .allow(null, "") // allow empty value
      .messages({
        "alternatives.match":
          "Invalid image format. Only JPG, JPEG, PNG, HEIC are allowed.",
      }),

    //  .messages({
    //   "any.required": "Please upload a photo.",
    //   "string.pattern.base":
    //     "Invalid image format. Only JPG, JPEG, PNG, HEIC are allowed.",
    // }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = myProfileSchema;
